<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/"
                                                                       *ngIf="user.role == 'ROLE_ADMIN'">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Orders</li>
    </ol>
  </nav>
  <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row align-items-center">
    <div class="col">
      <ul class="list-inline tab-list deskContent">
        <ng-container *ngFor="let om of ordersMainMenu">
          <li *ngIf="om.additional === 'N'" class="list-inline-item">
            <a (click)="populateTabData(om.tabClicked,om.orderStatus); tabChange();"
               [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
          </li>
        </ng-container>
        <li class="list-inline-item">
          <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">+ more</a>
          <div class="dropdown-menu dropdown-menu2">
            <ng-container *ngFor="let om of ordersMainMenu">
              <a *ngIf="om.additional === 'Y'" class="dropdown-item"
                 (click)="populateTabData(om.tabClicked,om.orderStatus);switchPosition(om)"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
            </ng-container>
          </div>
        </li>
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
        <option *ngFor="let u of ordersMainMenu" [ngValue]="u.orderStatus" selected>{{u.displayName}}</option>
      </select>
    </div>
    <div class="col text-right" [hidden]="tabClicked ==='exception'">
      <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile"
              *ngIf="(checkedList?.length) && tabClicked !== 'all'">
        Actions
      </button>

      <a data-toggle="modal" placement="bottom" ngbTooltip="Import" data-target="#myModal" class="ml-3"
         *ngIf="user.role == 'ROLE_ADMIN'">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
          <defs>
            <style>.a {
              fill: #8a55bb !important;
            }

            .b {
              fill: #fff;
            }</style>
          </defs>
          <g transform="translate(4 2.5)">
            <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
            <path class="b"
                  d="M.457,8.222A.458.458,0,0,0,0,8.679v.914a.458.458,0,0,0,.457.457h3.2V8.222ZM14.417,3,11.622.2a.685.685,0,0,0-.485-.2h-.174V3.654h3.654V3.48A.683.683,0,0,0,14.417,3Zm-4.368.885V0H4.339a.684.684,0,0,0-.685.685V8.222H7.309V6.361a.458.458,0,0,1,.782-.323L10.82,8.793a.486.486,0,0,1,0,.685L8.088,12.23a.458.458,0,0,1-.782-.323V10.049H3.654v3.883a.684.684,0,0,0,.685.685h9.593a.684.684,0,0,0,.685-.685V4.568H10.734A.687.687,0,0,1,10.049,3.883Z"
                  transform="translate(3.356 5.479)"/>
          </g>
        </svg>
      </a>
      <a placement="bottom" ngbTooltip="Export" class="ml-3" *ngIf="user.role == 'ROLE_ADMIN'">
        <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30">
          <defs>
            <style>.a {
              fill: #8a55bb !important;
            }

            .b {
              fill: #fff;
            }</style>
          </defs>
          <g transform="translate(4 2.5)">
            <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
            <path class="b"
                  d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z"
                  transform="translate(3.386 5.171)"/>
          </g>
        </svg>
      </a>
      <a placement="bottom" ngbTooltip="Create" class="ml-3" *ngIf="user.role == 'ROLE_ADMIN'">
        <svg xmlns="http://www.w3.org/2000/svg" (click)="submitOrder()" width="30" height="30" viewBox="0 0 30 30">
          <defs>
            <style>.a {
              fill: #8a55bb !important;
            }

            .b {
              fill: #fff;
            }</style>
          </defs>
          <g transform="translate(4 2.5)">
            <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
            <path class="b"
                  d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                  transform="translate(2.823 3.938)"/>
          </g>
        </svg>
      </a>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}"
           style="min-height:580px!important;">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th></th>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th>Order Date</th>
            <th>Channel / Source</th>
            <th>Sender Name</th>
            <th>Receiver Name</th>
            <th *ngIf="tabClicked == 'onHold'">Age of Order</th>
            <th>Payment Method</th>
            <th>Status</th>
            <th></th>
          </tr>

          </thead>
          <tbody class="table-body-custom">

          <tr *ngFor="let o of orders">
            <td>
              <div class="form-checkbox" *ngIf="tabClicked == 'submitted' || tabClicked == 'onHold'"><input
                type="checkbox" id="{{o.orderHeaderId}}" [(ngModel)]="o.isSelected" name="list_name"
                (change)="selectShip(o)">
                <label for="{{o.orderHeaderId}}"></label></div>
            </td>
            <td><a routerLink="/admin/viewOrders/{{o.orderHeaderId}}">{{o.orderNumber}}</a></td>
            <td>{{o.sourceOrderId || '--'}}</td>
            <td>{{o.createdDate}}</td>
            <td>{{(o.connectionName ? (o.connectionName + '/') : '') | titlecase}}{{o.channelName | replaceStatus}}</td>
            <td>{{o.senderName}}</td>
            <td>{{o.receiverName}}</td>
            <td *ngIf="tabClicked == 'onHold'">{{o.noOfDaysOnHold || '--'}} {{'ago'}}</td>
            <td>{{(o?.paymentMethod == 'COD' ? 'Cash On Delivery' :(o?.paymentMethod | replaceStatus)) || '--'}}</td>
            <td>
              <div class="text-truncate" title="{{(o.orderStatus == 'READY_TO_SHIP' ? 'Awaiting Pickup':
                (o.orderStatus == 'SHIPPED' ? 'Shipped':
                (o.orderStatus == 'IN_TRANSIT' ? 'In Transit':
                (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label':
                (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': o.orderStatus ))))) | replaceStatus}}"
                   style="width:100px;">{{(o.orderStatus == 'READY_TO_SHIP' ? 'Awaiting Pickup' :
                (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                  (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                    (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                      (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : o.orderStatus))))) | replaceStatus}}
              </div>
            </td>
            <td>
              <div
                *ngIf="o.thirdPartyTrackingNum !== null">
                <a routerLink="/trackOutboundOrder/{{o.orderHeaderId}}/{{o.accountOwnerId}}" target="_blank">
                  <img src="assets/images/dsBuffer.png" width="30" height="30" alt="trackImage">
                </a>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="orders?.length===0|| !orders?.length">
            <td colspan="9" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th width="200px;" style="width: 0px!important;">Order Date</th>
            <th>Channel / Source</th>
            <th width="200px;">Sender Name</th>
            <th>Receiver Name</th>
            <th *ngIf="tabClicked == 'onHold'">Age of Order</th>
            <th *ngIf="user.role==='ACCOUNT_OWNER'" style="width:110px!important;">Payment Method</th>
            <th>Status</th>
          </tr>

          </thead>
          <tbody>
          <tr *ngFor="let o of orders">
            <td>
              <b class=" tablesaw-cell-label">Order #</b>
              <span class="tablesaw-cell-content">
                 <a routerLink="/admin/viewOrders/{{o.orderHeaderId}}">{{o.orderNumber}}</a></span>
  </td>
  <td><b class=" tablesaw-cell-label">Source Order</b><span class="tablesaw-cell-content"> {{o.sourceOrderId || '--'}}</span></td>
  <td><b class=" tablesaw-cell-label">Source Data</b><span class="tablesaw-cell-content">  {{o.createdDate}}</span>
  </td>
  <td><b class=" tablesaw-cell-label">Channel Name</b>
    <span class="tablesaw-cell-content"> {{(o.connectionName ? (o.connectionName + '/') : '') | titlecase}}{{o.channelName | titlecase}}</span>
  </td>
  <td><b class=" tablesaw-cell-label">Sender Name</b>
    <span class="tablesaw-cell-content"> {{o.senderName}}</span>
  </td>
  <td><b class=" tablesaw-cell-label">Receiver Name</b>
    <span class="tablesaw-cell-content">{{o.receiverName}}</span></td>
  <td *ngIf="tabClicked == 'onHold'"><b class=" tablesaw-cell-label">Age Of Order</b>
    <span class="tablesaw-cell-content">{{o.noOfDaysOnHold}}</span></td>
  <td *ngIf="user.role==='ACCOUNT_OWNER'"><b class=" tablesaw-cell-label">Payment Method</b>
    <span class="tablesaw-cell-content">{{(o?.paymentMethod == 'COD' ? 'Cash On Delivery' :(o?.paymentMethod | replaceStatus)) || '--'}}</span></td>
  <td><b class=" tablesaw-cell-label">Status</b>
    <span class="tablesaw-cell-content">
                <div class="text-truncate" title="{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned':
                  (o.orderStatus == 'SHIPPED' ? 'Shipped':
                  (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier':
                  (o.orderStatus == 'IN_TRANSIT' ? 'In Transit':
                  (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label':
                  (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': o.orderStatus )))))) |replaceStatus}}"
                     style="width:100px;">{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned' :
                  (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                    (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                      (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                        (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                          (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : o.orderStatus)))))) |replaceStatus}}
                </div>
              </span>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<div class="modal fade importorder" id="myModal" role="dialog" style="margin-left: 40px;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="importOrders">Import Order</h4>
        <button type="button" class="close" (click)="removeFile()" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <p style="font-size:15px">To import your orders, please create a CSV file with following details and upload.
          <br/>Sample file can be accessed <a
            href="https://shift-images.s3.ap-south-1.amazonaws.com/import-orders+shift.csv"
            target="_blank">here</a>
        </p>
        <div class="row">
          <div class="col" style="height:44px; padding-right:23px;">
            <label class="import_products add_file">
              <input class="shift-import-input" type="file" (change)="loadorder($event)" [(ngModel)]="productImage"
                     [ngModelOptions]="{standalone: true}" name="file" accept="application/csv+json"/>
              <span *ngIf="!productImage || productImage == ''"> <img src="/./assets/images/Group_1645.svg"
                                                                      style="margin-right: 10px;" alt="productImage">Add file</span>
              <span *ngIf="productImage"><img src="/./assets/images/xx.png" style="margin-right: 10px;width:20px;"
                                              (click)="removeFile()"
                                              alt="productImage">{{getFileName(productImage)}}</span>

            </label>
            <div id="statusText2" class="invalid-feedback d-block mb-2" [hidden]="!statusText2">{{statusText2}}</div>
            <button type="button" *ngIf="productImage" style="margin-bottom:50px;"
                    class="btn btn-orange file shift-import ml-2" [attr.data-dismiss]="uploadDismissModal"
                    (click)="submitImportOrder()" data-toggle="modal" [attr.data-target]="uploadPopup">
              Import
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--successful model-box-->
<div class="modal fade style-modal" id="myModalOne" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-img">
        <svg viewBox="0 0 60 60" width="80" xmlns="http://www.w3.org/2000/svg">
          <g id="Page-1" fill="none" fill-rule="evenodd">
            <g id="009---message-alert" fill="rgb(0,0,0)" fill-rule="nonzero" transform="translate(0 -1)">
              <path fill="#fff" id="Shape"
                    d="m59.975 21.81c-.0252119-.0879777-.0562813-.1741701-.093-.258-.0165345-.0342915-.0348942-.0676727-.055-.1-.009-.013-.01-.029-.019-.042s-.039-.031-.056-.051c-.0342726-.0402735-.0717265-.0777274-.112-.112-.02-.016-.029-.039-.05-.054l-14.208-10.384c-2.7840647-5.98497874-8.7868578-9.81173501-15.3876898-9.80958972-6.6008319.00214529-12.6011364 3.83280259-15.3813102 9.81958972l-14.203 10.373c-.021.016-.031.039-.051.056-.03970013.0341976-.07680243.0712999-.111.111-.017.02-.04.03-.056.051s-.01.028-.018.041c-.02056309.0322353-.03926046.0656235-.056.1-.0221803.0458712-.04089917.0933369-.056.142-.01473554.0378589-.02709291.076601-.037.116-.00585317.038408-.0091936.077157-.01.116 0 .026-.015.048-.015.074v34.001c.0026002 1.0569743.3431929 2.0854101.972 2.935.013.021.015.045.03.065s.054.04.078.066c.93831391 1.2149146 2.38493592 1.9286307 3.92 1.934h50c1.5350641-.0053693 2.9816861-.7190854 3.92-1.934.024-.026.057-.037.078-.066s.017-.044.03-.065c.6288071-.8495899.9693998-1.8780257.972-2.935v-34c0-.026-.013-.048-.015-.074-.0008483-.0388408-.0041885-.0775871-.01-.116zm-1.975 34.19c-.0040922.3120758-.0574149.6215501-.158.917l-22.469-16.417 22.627-16.531zm-55.842.917c-.10058511-.2954499-.15390784-.6049242-.158-.917v-32.031l22.627 16.531zm1.906-33.917h9.689c2.1961004 7.1310199 8.7854786 11.9965021 16.247 11.9965021s14.0508996-4.8654822 16.247-11.9965021h9.689l-23.667 17.289c-1.358139.9387072-3.1540696.9442723-4.518.014zm51.874-2h-9.219c.4278862-2.2765162.3665279-4.6180181-.18-6.869zm-25.938-18c8.2842712 0 15 6.71572875 15 15 0 8.2842712-6.7157288 15-15 15s-15-6.7157288-15-15c.0093685-8.28038757 6.7196124-14.99063148 15-15zm-16.719 18h-9.216l9.394-6.862c-.5446808 2.2489086-.6053535 4.5878769-.178 6.862zm-8.281 38c-.58034452-.0004564-1.14791851-.1704158-1.633-.489l22.956-16.774.268.2c.9990958.6908994 2.185285 1.0603624 3.4 1.059 1.2279919.0003388 2.4267976-.3743752 3.436-1.074l.248-.181 22.958 16.77c-.4850815.3185842-1.0526555.4885436-1.633.489z"/>
              <path fill="#fff" id="Shape"
                    d="m5 29c-.55228475 0-1 .4477153-1 1v10c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-10c0-.5522847-.44771525-1-1-1z"/>
              <path fill="#fff" id="Shape"
                    d="m5 43c-.55228475 0-1 .4477153-1 1v3c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-3c0-.5522847-.44771525-1-1-1z"/>
              <path fill="#fff" id="Shape"
                    d="m22 26h4c0 2.209139 1.790861 4 4 4s4-1.790861 4-4h4c.5522847 0 1-.4477153 1-1v-2c-.0052514-1.2667854-.8056491-2.3937454-2-2.816v-5.184c-.0031107-2.732017-1.5953871-5.21257906-4.078-6.353.2802069-1.20469622-.2076506-2.45787802-1.2286269-3.15603002-1.0209764-.69815201-2.3657698-.69815201-3.3867462 0-1.0209763.698152-1.5088338 1.9513338-1.2286269 3.15603002-2.4826129 1.14042094-4.0748893 3.620983-4.078 6.353v5.184c-1.1943509.4222546-1.9947486 1.5492146-2 2.816v2c0 .5522847.4477153 1 1 1zm8 2c-1.1045695 0-2-.8954305-2-2h4c0 1.1045695-.8954305 2-2 2zm-1-20c0-.55228475.4477153-1 1-1s1 .44771525 1 1c0 .028-.01.051-.012.078-.6545662-.10393871-1.3214338-.10393871-1.976 0-.002-.027-.012-.05-.012-.078zm-4 7c0-2.7614237 2.2385763-5 5-5s5 2.2385763 5 5v5h-10zm-2 8c0-.5522847.4477153-1 1-1h12c.5522847 0 1 .4477153 1 1v1h-14z"/>
            </g>
          </g>
        </svg>
      </div>
      <div class="modal-body">
        <p class="mb-5">Uploaded Successfully.</p>
        <div class="text-right">
          <button type="button" class="btn btn-optional" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Tracking Details popup-->
<div class="modal fade" id="orderDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header">
        <h2 class="modal-title" id="trackingDetails">Tracking Details</h2>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <!--Body-->
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div [hidden]="awb.tracking_data.error==null">
              <label class="text-black"><b>Info :</b><span class="ml-1">{{awb.tracking_data.error}}</span></label><br>
            </div>
            <div [hidden]="awb.tracking_data.error!=null">
              <label class="text-black"
                     *ngFor="let s of awb.tracking_data.shipment_track_activities"><b>Activity:</b><span
                class="ml-1">{{s.activity}}</span></label><br>
              <div *ngFor="let s of awb.tracking_data.shipment_track">
                <label class="text-black"><b> Delivered to :</b><span class="ml-1">{{s.delivered_to}}</span></label><br>
                <label class="text-black"><b>Status :</b><span class="ml-1"></span>{{s.current_status}}</label><br>
              </div>
              <label class="text-black"><b>Estimated Delivery date :</b><span class="ml-1">{{awb.tracking_data.edd |
                date : "dd-MMM-yyyy"}}</span></label>
            </div>
          </div>
        </div>
      </div>
      <!--Footer-->
    </div>
  </div>
</div>

<div class="modal fade right" id="exampleModalPreview" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalPreviewLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-fluid modal-dialog-scrollable" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="exampleModalPreviewLabel">Shipping label</h5>
        <button type="button" class="close " data-dismiss="modal" aria-label="Close">
          <span style="font-size: 1.3em;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="inner-box">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col">
                        <div class="invoice-title">
                          <h2 class="ml-2"></h2>
                          <h2 class="float-right">Order# 12345</h2>
                        </div>
                        <hr>
                        <div class="row mt-2">
                          <div class="col-md-6">
                            <address class="ml-2">
                              <strong>Shipping To:</strong><br>
                              Buyer's Name<br>
                              Flat No.1, XYZ street<br>
                              India, Pin Code - XXXXX<br>
                            </address>
                          </div>
                          <div class="col-md-6 text-right">
                            <address>
                              <label><b>Courier :</b> Shift</label><br>
                              Barcode<br>
                              <label><b>Awb :</b> 4703900XXXX</label>
                            </address>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <address class="ml-2">
                              <label>Phone Num - 9887373XXX</label>
                            </address>
                          </div>
                          <div class="col-md-6 text-right">
                            <address>
                              <label><b>Routing Code :</b> ZKPZKP</label>
                            </address>
                          </div>
                        </div>
                        <div class="row shift-border-top">
                          <div class="col-md-4 mt-3">
                            <address class="ml-2">
                              <label>Dimensions - 15.0 X 19.0 x 9.0</label>
                            </address>
                          </div>
                          <div class="col-md-4 mt-3">
                            <address>
                              <label>Weight - 0.3 KG</label>
                            </address>
                          </div>
                          <div class="col-md-4 mt-3">
                            <address>
                              <label>Cash on Delivery AMOUNT : 3550.00 INR</label>
                            </address>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <address class="ml-2">
                              <label>Payment : Cash on Delivery</label>
                            </address>
                          </div>
                          <div class="col-md-4">
                            <address class="shift-add-font">
                              <label>Items(s) : ABC Product</label>
                            </address>
                          </div>
                          <div class="col-md-4"></div>
                        </div>
                        <div class="row shift-border-top">
                          <div class="col-md-6 mt-3">
                            <address class="ml-2">
                              <strong>Shipping By:</strong><br>
                              Snithik Technology<br>
                              Lanco Hills, Hyderabad<br>
                              Telangana, Pin Code - 2220xx<br><br>
                              Phone Num - 93245XXXX
                            </address>
                          </div>
                          <div class="col-md-6 text-right mt-3">
                            <address>
                              <label><b>Order# :</b> 6662444XX</label><br>
                              Barcode
                            </address>
                          </div>
                        </div>
                        <div class="shift-border-top"></div>
                        <h6 class="mt-3"><label><b>Terms and Conditions</b></label></h6>
                        <div class="row">
                          <div class="col">
                            <label>1.Visit official website of Shift to view the Condition of Carriage.</label><br>
                            <label>2.Shipping charges are inclusive of service tax and all figure are in INR.</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button class="btn btn-cancel" type="button" data-dismiss="modal" aria-label="Close">Close</button>
              <button type="submit" class="btn btn-orange ml-1">Print</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div [ngStyle]="{'display': popUpAssign =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': popUpAssign == 'Y'}" class="modal" id="popUpAssign" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel">Assign Order</h5>
        <div id="errorMessage" class="invalid-feedback d-block" [hidden]="!errorMessage">{{errorMessage}}</div>
        <button type="button" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="inner-box">
                <div class="col">
                  <label for="user">Select Resource</label>
                  <select class="form-control" id="user" [(ngModel)]="userDrop" [ngModelOptions]="{standalone: true}"
                          required>
                    <option *ngFor="let u of userList" [ngValue]="u.id">{{u.firstName}}</option>
                  </select>
                </div>
                <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">
                  {{statusText1}}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="submitAssign()">Assign</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal fade right" id="exampleModalPreviewPick" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalPreviewLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-fluid modal-dialog-scrollable" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="exampleModalPreviewLabelp"></h5>
        <button type="button" class="close " data-dismiss="modal" aria-label="Close">
          <span style="font-size: 1.3em;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">

            <div class="col-md-12 text-right">
              <button class="btn btn-cancel" type="button" data-dismiss="modal" aria-label="Close">Cancel</button>
              <button type="submit" class="btn btn-orange ml-2">Print</button>
            </div>
          </div>
          <div>
            <div class="row mt-3">
              <div class="col">
                <div class="inner-box">


                  <div class="row">

                    <div class="col-md-4">

                      <address class="ml-2">
                        <label>Order No : {{modalPickLine?.orderNumber}}</label>
                        <label class="d-block">Customer Details : {{modalPickLine?.accountOwnerName}}</label>
                        <label class="d-block">{{modalPickLine?.accountOwnerCompany}}</label>
                      </address>
                    </div>

                    <div class="col-md-4">
                      <address class="ml-2">

                        <label><b>Pick Slip</b></label>
                      </address>
                    </div>
                    <div class="col-md-4 text-dark-right">
                      <address class="ml-2">

                        <ngx-barcode [bc-value]="modalPickLine.orderHeaderId" [bc-display-value]="false"></ngx-barcode>

                      </address>
                    </div>
                  </div>
                  <div class="row">

                    <div class="col-md-4">

                      <address class="ml-2">
                        <label class="d-block">Ship To : {{modalPickLine.accountOwnerCustomerName}}</label>
                        <label class="d-block">{{modalPickLine.accountOwnerCustomerCompanyName}}</label>
                        <label class="d-block">{{modalPickLine.accountOwnerCustomerEmail}}</label>
                        <label class="d-block">{{modalPickLine.accountOwnerCustomerPhone}}</label>
                        <label class="d-block">{{modalPickLine.accountOwnerCustomerAddressText}}</label>
                      </address>
                    </div>

                    <div class="col-md-4">
                      <address class="ml-2">
                        <label>Ordered Date : {{modalPickLine.orderedDate}}</label>
                      </address>
                    </div>
                    <div class="col-md-4 text-dark-right">
                      <address class="ml-2">
                        <label class="d-block">Return Address :</label>
                        <label class="d-block">{{modalPickLine.warehouseName}}</label>
                        <label class="d-block">{{modalPickLine.warehouseAddressText}}</label>
                      </address>
                    </div>
                  </div>
                  <div class="row">

                    <div class="col-md-4">

                      <address class="ml-2">
                        <label>Delivery Instruction : {{modalPickLine.deliveryInstructions}}</label>
                      </address>
                    </div>

                  </div>


                  <div class="row">
                    <div class="col-md-12">
                    </div>
                  </div>

                  <table class="table">
                    <tr>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Ordered Quantity</th>
                      <th>Bin Location</th>
                      <th>Bar Code</th>
                    </tr>
                    <tr *ngFor="let l of modalPickLine?.pickSlipData">
                      <td>{{l.sku|uppercase}}</td>
                      <td>{{l.productName|titlecase}}</td>
                      <td>{{l.quantity}}</td>
                      <td>{{l.binLocation}}</td>
                      <td>
                        <ngx-barcode [bc-value]="l.productId" [bc-display-value]="false"></ngx-barcode>
                      </td>

                    </tr>
                  </table>

                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': popUpGenerate =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': popUpGenerate == 'Y'}" class="modal" id="popUpGenerate" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog modal-fluid modal-dialog-scrollable" role="document">
    <div class="snk-modal-content modal-content">
      <div class="snk-modal-header modal-header text-center">
        <h5 class="modal-title w-100" id="exampleModalPreviewLabel3">Shipping label</h5>
        <button type="button" class="close" (click)="closePopUpGenerate()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <button class="btn btn-cancel" id="close" type="button" (click)="closePopUpGenerate()" aria-label="Close">
                Close
              </button>
              <button type="submit" id="print" class="btn btn-orange ml-2">Print</button>
            </div>
          </div>
          <div>
            <div class="row mt-3">
              <div class="col">
                <div class="row">
                  <div class="col-md-12 text-right">
                    <label>Print Copy : {{grant?.printCopy | titlecase}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="w-100 " [hidden]="grant?.productConfig!=='SKU'">
                    <ng-container *ngFor="let g of productList;let i = index;">
                      <div class="inner-box mt-2 mx-3">
                        <div class="row">
                          <div class="col-md-7">
                            <label>Box# : {{i + 1}} of {{productList.length}}</label><br>
                            <label class="text-body">Dimensions : {{g.length}} x {{g.width}} x{{g.height}} (L W
                              H)</label><br>
                            <label class="text-body">Weight : {{g.weight}} grams</label><br>
                          </div>
                          <div class="col-md-5 text-dark-right">
                            <ngx-barcode [bc-element-type]="elementType" [bc-value]="barCodeValue" [bc-format]="format"
                                         [bc-line-color]="lineColor" [bc-width]="width" [bc-height]="height"
                                         [bc-display-value]="displayValue" [bc-font-options]="fontOptions"
                                         [bc-font]="font"
                                         [bc-text-align]="textAlign" [bc-text-position]="textPosition"
                                         [bc-text-margin]="textMargin" [bc-font-size]="fontSize"
                                         [bc-background]="background"
                                         [bc-margin]="margin" [bc-margin-top]="marginTop"
                                         [bc-margin-bottom]="marginBottom"
                                         [bc-margin-left]="marginLeft" [bc-margin-right]="marginRight"></ngx-barcode>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <h2 class="text-body mb-3"><b>From:{{grant?.warehouseName}}</b></h2>
                            <label class="text-body"><b>{{grant?.warehouseAddressText}}</b></label><br>
                          </div>
                          <div class="col-md-3">
                            <h2 class="text-body mb-3"><b>To:{{grant?.contactName}}</b></h2>
                            <label class="text-body"><b>{{grant?.contactAddressText}}</b></label><br>
                            <label class="text-body"><b>{{grant?.contactPhone}}</b></label><br>
                          </div>
                          <div class="col-md-2">
                            <div *ngIf="grant?.hasFragileItem=='Y'">
                              <img src="assets/images/glass.png" [width]="128"><br>
                            </div>
                          </div>
                          <div class="col-md-4 text-dark-right">
                            <qrcode [qrdata]="myAngularxQrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <h2 class="text-black mb-3">Box Details</h2>
                          </div>
                        </div>
                        <table class="table">
                          <tr>
                            <th>Product Name</th>
                            <th>SKU</th>
                            <th>Quantity</th>
                          </tr>
                          <ng-container>
                            <tr>
                              <td>{{g.productName}}</td>
                              <td>{{g.sku}}</td>
                              <td>{{g.qtyPerBox}}</td>
                            </tr>
                          </ng-container>
                        </table>
                      </div>
                    </ng-container>
                  </div>

                  <div class="w-100 " [hidden]="grant?.productConfig!=='MULTI_SKU'">
                    <ng-container *ngFor="let g of productList;let i = index;">
                      <div class="inner-box mt-2 mx-3">
                        <div class="row">
                          <div class="col-md-7">
                            <label>Box# : {{i + 1}} of {{productList.length}}</label><br>
                            <label class="text-body">Dimensions : {{g.length}} x {{g.width}} x{{g.height}} (L W
                              H)</label><br>
                            <label class="text-body">Weight : {{g.weight}} grams</label><br>
                          </div>
                          <div class="col-md-5 text-dark-right">
                            {{grant?.shipmentIdentifier}}
                            <ngx-barcode [bc-element-type]="elementType" [bc-value]="barCodeValue" [bc-format]="format"
                                         [bc-line-color]="lineColor" [bc-width]="width" [bc-height]="height"
                                         [bc-display-value]="displayValue" [bc-font-options]="fontOptions"
                                         [bc-font]="font"
                                         [bc-text-align]="textAlign" [bc-text-position]="textPosition"
                                         [bc-text-margin]="textMargin" [bc-font-size]="fontSize"
                                         [bc-background]="background"
                                         [bc-margin]="margin" [bc-margin-top]="marginTop"
                                         [bc-margin-bottom]="marginBottom"
                                         [bc-margin-left]="marginLeft" [bc-margin-right]="marginRight"></ngx-barcode>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <h2 class="text-body mb-3"><b>From:{{grant?.warehouseName}}</b></h2>
                            <label class="text-body"><b>{{grant?.warehouseAddressText}}</b></label><br>
                          </div>
                          <div class="col-md-3">
                            <h2 class="text-body mb-3"><b>To:{{grant?.destWarehouseName}}</b></h2>
                            <label class="text-body"><b>{{grant?.destWarehouseAddressText}}</b></label><br>
                          </div>
                          <div class="col-md-2">
                            <div *ngIf="grant?.hasFragileItem=='Y'">
                              <img src="assets/images/glass.png" [width]="128"><br>
                            </div>
                          </div>
                          <div class="col-md-4 text-dark-right">
                            <qrcode [qrdata]="myAngularxQrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <h2 class="text-black mb-3">Box Details</h2>
                          </div>
                        </div>
                        <table class="table">
                          <tr>
                            <th>Product Name</th>
                            <th>SKU</th>
                            <th>Quantity</th>
                          </tr>
                          <ng-container>
                            <tr *ngFor="let p of g.pList">
                              <td>{{p.productName}}</td>
                              <td>{{p.sku}}</td>
                              <td>{{p.qtyPerBox}}</td>
                            </tr>
                          </ng-container>
                        </table>
                      </div>
                    </ng-container>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div [ngStyle]="{'display': pickSlipPopUp =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': pickSlipPopUp == 'Y'}" class="modal" id="pickSlipPopUp2" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <button type="button" class="close" (click)="closePickSlipPop()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <div class="row mt-3">
          <div class="col">
            <div class="inner-box">


              <div class="row">
                <div class="col-md-4">
                  <label class="d-block"><b>Readers</b></label>
                </div>

                <div class="col-md-8 text-right">
                  <label class="d-block"><b>Pick List</b></label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">

                  <address class="ml-2">
                    <label><b>{{modalPickLine.warehouseName}}</b></label>
                    <label class="d-block">{{modalPickLine.warehouseAddressText}}</label>
                  </address>
                </div>

                <div class="col-md-8 text-right">
                  <address class="ml-2">
                    <label class="d-block"><u>Order Number : {{modalPickLine.orderNumber}}</u></label>

                  </address>
                </div>
              </div>


              <div class="row">
                <div class="col-md-12">
                </div>
              </div>

              <table class="table">
                <tr>
                  <th>SKU</th>
                  <th>Product Name</th>
                  <th>Ordered Quantity</th>
                  <th>Bin Location</th>
                </tr>
                <tr *ngFor="let l of modalPickLine?.pickSlipData">
                  <td>{{l.sku|uppercase}}</td>
                  <td>{{l.productName|titlecase}}</td>
                  <td>{{l.quantity}}</td>
                  <td>{{l.binLocation}}</td>


                </tr>
              </table>

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<div [ngStyle]="{'display': pdfGenerate =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': pdfGenerate == 'Y'}" class="modal" id="popUpHold" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Select Size</h5>
        <button type="button" id="enterQuantity" class="close" (click)="close()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row">
            <div class="col-8">
              <div class="form-group required">
                <label class="control-label" for="printSize2">Print Size Option</label>
                <select class="form-control" id="printSize2" [(ngModel)]="size" [ngModelOptions]="{standalone: true}"
                        [ngClass]="{'is-invalid':sizeError}" required>
                  <option>A4</option>
                  <option>A5</option>
                  <option>Custom</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!sizeError">{{sizeError}}</div>
              </div>
            </div>


            <div class="col-4 mt-4 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="printShipment()">Submit</button>
            </div>

          </div>


        </form>
      </div>
    </div>
  </div>
</div>


<div [ngStyle]="{'display': pickSlipPDF =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': pickSlipPDF == 'Y'}" class="modal" id="pickSlipPDF" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="pickSlipPDFLabel">Select Size</h5>
        <button type="button" id="closePopUp" class="close" (click)="closePickSlipPdf()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row">
            <div class="col-8">
              <div class="form-group required">
                <label class="control-label" for="pickSlipId">Print Size Option</label>
                <select class="form-control" id="pickSlipId" [(ngModel)]="pickSlipSize"
                        [ngModelOptions]="{standalone: true}"
                        [ngClass]="{'is-invalid':pickSlipSizeError}" required>
                  <option>A4</option>
                  <option>A5</option>
                  <option>Custom</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!pickSlipSizeError">{{pickSlipSizeError}}</div>
              </div>
            </div>


            <div class="col-4 mt-4 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="printPickSlip()">Submit</button>
            </div>

          </div>


        </form>
      </div>
    </div>
  </div>
</div>
